import React from 'react';
import {
  string, shape, arrayOf, func, number, bool
} from 'prop-types';
import {
  Button,
  Radio,
  RadioGroup,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { DELIMITER } from './Constants';

export const Quotes = ({
  quoteList,
  selectQuote,
  selectedQuote,
  showLoadMore,
  quotesPageSize,
  setQuotesPageSize
}) => {

  const handleLoadMore = () => {
    setQuotesPageSize(quotesPageSize + 20);
  };

  return (
    <div className="sui-pt-10">
      <RadioGroup
        aria-labelledby="quote-names"
        name="quote-names"
      >
        {quoteList.map((quote, i) => (
          <SelectionControlLabel
            key={quote.quoteId}
            id={quote.quoteId}
            onChange={selectQuote}
            value={`${quote.quoteId}${DELIMITER}${quote.userId}${DELIMITER}${quote.name}`}
            label={quote.name}
            checked={selectedQuote.quoteId === quote.quoteId}
            padding
          >
            <Radio />
          </SelectionControlLabel>
        ))}
      </RadioGroup>
      {showLoadMore && (
        <Button variant="text" onClick={handleLoadMore}> Load More...</Button>
      )}
    </div>
  );
};

Quotes.propTypes = {
  quoteList: arrayOf(shape({
    name: string,
  })),
  selectQuote: func.isRequired,
  selectedQuote: shape({
    quoteId: string.isRequired,
    quoteName: string.isRequired,
    userId: string.isRequired
  }).isRequired,
  showLoadMore: bool.isRequired,
  quotesPageSize: number.isRequired,
  setQuotesPageSize: func.isRequired
};

Quotes.defaultProps = {
  quoteList: [],
};

Quotes.displayName = 'AddToQuoteQuotes';
